/* eslint-disable @next/next/no-sync-scripts */
import Head from "next/head";
import { useFeatureFlags } from "../context/FeatureFlagsProvider";
export var ZendeskProvider = function (_a) {
    var children = _a.children;
    var featureFlags = useFeatureFlags();
    return (<>
      {featureFlags.flags["zendesk"] && (<Head>
          <script id="ze-snippet" src="https://static.zdassets.com/ekr/snippet.js?key=312901b6-8fc7-4683-b15b-2a54abc73a62">
            {" "}
          </script>
        </Head>)}

      {children}
    </>);
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiWmVuZGVza1Byb3ZpZGVyLmpzeCIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIlplbmRlc2tQcm92aWRlci50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsK0NBQStDO0FBQy9DLE9BQU8sSUFBSSxNQUFNLFdBQVcsQ0FBQztBQUU3QixPQUFPLEVBQUUsZUFBZSxFQUFFLE1BQU0saUNBQWlDLENBQUM7QUFFbEUsTUFBTSxDQUFDLElBQU0sZUFBZSxHQUFHLFVBQUMsRUFBWTtRQUFWLFFBQVEsY0FBQTtJQUN4QyxJQUFNLFlBQVksR0FBRyxlQUFlLEVBQUUsQ0FBQztJQUV2QyxPQUFPLENBQ0wsRUFDRTtNQUFBLENBQUMsWUFBWSxDQUFDLEtBQUssQ0FBQyxTQUFTLENBQUMsSUFBSSxDQUNoQyxDQUFDLElBQUksQ0FDSDtVQUFBLENBQUMsTUFBTSxDQUNMLEVBQUUsQ0FBQyxZQUFZLENBQ2YsR0FBRyxDQUFDLHFGQUFxRixDQUV6RjtZQUFBLENBQUMsR0FBRyxDQUNOO1VBQUEsRUFBRSxNQUFNLENBQ1Y7UUFBQSxFQUFFLElBQUksQ0FBQyxDQUNSLENBRUQ7O01BQUEsQ0FBQyxRQUFRLENBQ1g7SUFBQSxHQUFHLENBQ0osQ0FBQztBQUNKLENBQUMsQ0FBQyJ9